import { Box, Grid, styledComponent, Typography } from '@hermes/web-components'

export const SearchLayoutContainer = styledComponent(Grid)(({ theme }) => ({
  ...theme.custom.SearchLayout,
  paddingBottom: '20px',
  overflowX: 'hidden',
  flexDirection: 'column'
}))

export const ContentContainer = styledComponent(Grid)(({ theme }) => ({
  marginTop: '32px',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  gap: '34px',
  [theme.breakpoints.down('lg')]: {
    marginTop: '16px'
  }
}))

export const TitleContainer = styledComponent(Box)(({ theme }) => ({
  display: 'inline',
  '&::first-letter': {
    textTransform: 'uppercase'
  },
  [theme.breakpoints.down('lg')]: {
    paddingLeft: `${theme.spacing(2)}`,
    paddingRight: `${theme.spacing(2)}`
  }
}))

export const MediumBoldTypography = styledComponent(Typography)<{
  component?: string
}>(({ theme }) => ({
  fontSize: '15px',
  lineHeight: '20px',
  display: 'inline',
  fontWeight: 500,
  margin: 0,
  color: theme.palette.text.black900
}))

export const SearchResultsLayout = styledComponent(Grid)(({ theme }) => ({
  gap: '16px',
  overflow: 'hidden',
  [theme.breakpoints.down('lg')]: {
    gap: 0
  }
}))

export const SearchResultsTitle = styledComponent(Grid)(({ theme }) => ({
  gap: '15px',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '8px',
  [theme.breakpoints.down('lg')]: {
    marginBottom: '20px'
  }
}))
